export type JourneyStepTemplateValidation = {
  ok: boolean;
  sendgrid_template_id: string;
  validated_at: string;
  errors: string[];
  dynamic_attributes?: string[];
};

export function isJourneyStepTemplateValidated(step: Record<string, unknown>): boolean {
  const tv = step.template_validation as JourneyStepTemplateValidation | undefined;
  if (!tv?.ok) return false;
  return tv.sendgrid_template_id === String(step.sendgrid_template_id ?? "");
}

export function journeyStepValidationErrors(step: Record<string, unknown>): string[] {
  const tv = step.template_validation as JourneyStepTemplateValidation | undefined;
  if (!tv || tv.sendgrid_template_id !== String(step.sendgrid_template_id ?? "")) return [];
  if (tv.ok) return [];
  return tv.errors ?? [];
}

export function journeyStepTemplateValidationForStep(step: Record<string, unknown>): JourneyStepTemplateValidation | null {
  const tv = step.template_validation as JourneyStepTemplateValidation | undefined;
  if (!tv || tv.sendgrid_template_id !== String(step.sendgrid_template_id ?? "")) return null;
  return tv;
}

export function journeyStepDynamicAttributes(step: Record<string, unknown>): string[] | null {
  const tv = journeyStepTemplateValidationForStep(step);
  if (!tv || tv.dynamic_attributes === undefined) return null;
  return tv.dynamic_attributes;
}
